<div class="spen-ly-modal prod-upload">
  <div class="modal-dialog">
    <div class="inner">
      <div class="modal-heading">
        <h2 class="heading-text">{{ title }}</h2>
      </div>
      <div class="modal-content has-footer">
        <div class="content-inner">
          <div class="prod-upload-container">
            @for (message of messages; track $index) {
              <div class="prod-upload-text">{{ message }}</div>
            }
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="modal-actions is-right-actions">
          <button (click)="close()" class="spen-mod-btn is-default">OK</button>
        </div>
      </div>
    </div>
  </div>
</div>
